import { CSSProperties } from "react";
import ReactModal from "react-overlays/Modal";
import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    backdrop: {
      backgroundColor: theme.modal.backdrop,
    },
    modal: {
      backgroundColor: theme.modal.background,
    },
  };

  return styles;
};

export const Backdrop = styled.div`
  background-color: ${({ theme }) => theme.modal.backdrop};
  position: fixed;
  z-index: 99;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.8;
`;

export const Modal = styled(ReactModal)`
  position: fixed;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: ${constants.radius.card}px;
  outline: 0;

  /* Position modal lower on mobile for scrollable content */
  @media (max-width: 768px) {
    top: 55%;
    max-height: calc(100vh - 60px);
  }
`;
